import { render } from "./ProductUpsellsContainer.vue?vue&type=template&id=2eb349c0&scoped=true"
import script from "./ProductUpsellsContainer.vue?vue&type=script&lang=ts"
export * from "./ProductUpsellsContainer.vue?vue&type=script&lang=ts"

import "./ProductUpsellsContainer.vue?vue&type=style&index=0&id=2eb349c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2eb349c0"

export default script